export const navigationMobile = () => {
    const mobileMenu = document.getElementById('mobile_menu');
    const mobileMenuBurgerButton = document.getElementById('mobile-menu-burger');
    const screenOverlay = document.getElementById('screen-overlay-mobile');

    const links = mobileMenu.querySelectorAll(".level-1");
    const wrappersLevel2 = mobileMenu.querySelectorAll(".wrapper-2");
    const actionsLevel2 = mobileMenu.querySelectorAll(".actions-level-2");

    const linksLevel2 = mobileMenu.querySelectorAll(".level-2");
    const wrappersLevel3 = mobileMenu.querySelectorAll(".wrapper-3");

    const backButtons = mobileMenu.querySelectorAll(".back");
    const backButtons2 = mobileMenu.querySelectorAll(".back-2");

    const handleClick = ((event) => {
        if (mobileMenu.contains(event.target)) return;
        if (event.target === mobileMenuBurgerButton || mobileMenuBurgerButton.contains(event.target)) {
            toggleMenu();
        } else {
            closeMenu();
        }
    })

    const toggleMenu =  () => {
        mobileMenu.classList.toggle('active');
        screenOverlay.classList.toggle('active');
        mobileMenuBurgerButton.classList.toggle('active');
    }

    const closeMenu = ()=> {
        mobileMenu.classList.remove('active');
        screenOverlay.classList.remove('active');
        mobileMenuBurgerButton.classList.remove('active');
    }

    const hideLevel1 = () => {
        links.forEach(link => { link.classList.add('hidden') })
    }
    const hideLevel2 = () => {
        linksLevel2.forEach(link => { link.classList.add('hidden') })
        actionsLevel2.forEach(link => { link.classList.add('hidden') })
    }
    const showLevel1 = ()=> {
        links.forEach(link => { link.classList.remove('hidden') })
        wrappersLevel2.forEach(link => { link.classList.remove('active') })
    }

    const showLevel2 = () =>{
        linksLevel2.forEach(link => { link.classList.remove('hidden') })
        actionsLevel2.forEach(link => { link.classList.remove('hidden') })
        wrappersLevel3.forEach(link => { link.classList.remove('active') })
    }

    links.forEach(link => {
        link.addEventListener("click", (e) => {
            hideLevel1();
            e.target.nextElementSibling.classList.toggle('active');
        });
    });

    linksLevel2.forEach(link => {
        link.addEventListener("click", (e) => {
            hideLevel2();
            e.target.nextElementSibling.classList.toggle('active');
        });
    });

    backButtons.forEach(backButton => {
        backButton.addEventListener("click", (e) => {
            showLevel1();
        });
    });

    backButtons2.forEach(backButton => {
        backButton.addEventListener("click", (e) => {
            showLevel2();
        });
    });

    document.addEventListener('click', handleClick);
}
